import { StorageAdapter } from '../StorageAdapter';

export class SessionStorageAdapter extends StorageAdapter {
  constructor() {
    super(sessionStorage);
  }
}
